const webChannel = {
  Global: [
    "Amazon Prime Video",
    "Apple Music",
    "Apple News",
    "Apple TV+",
    "AsianCrush",
    "BMW Films",
    "BritBox",
    "Claro Video",
    "Comedy Crib",
    "Comic-Con HQ",
    "Crypt TV",
    "CZW Studios",
    "DAZN",
    "DDT Universe",
    "discovery+",
    "Disney+",
    "DisneyLife",
    "Eros Now",
    "F1TV",
    "Facebook Watch",
    "FilmBox Live",
    "FiteTV",
    "Flooxer",
    "Food Network Kitchen",
    "GagaOOLala",
    "Gaia",
    "Google Play",
    "GothamGirls.com",
    "HBO Go CEE",
    "HBO Nordic",
    "Highspots",
    "IGTV",
    "Independentwrestling TV",
    "Insight TV",
    "iQIYi",
    "iTunes",
    "LINE TV",
    "LUVE",
    "Lycos Network",
    "MEGOGO",
    "MotorTrend On Demand",
    "Neonalley",
    "Netflix",
    "NEWSWIREFM",
    "Olympic Channel",
    "Paramount+",
    "PassionFlix",
    "Planetscum",
    "PressTV DOC",
    "Quibi",
    "Rakuten TV",
    "Red Bull TV",
    "Rivit TV",
    "rocketjump.com",
    "Shahid",
    "Showmax",
    "Snapchat",
    "Sony Entertainment",
    "Star",
    "StardomWorld",
    "Starz Play",
    "Steam",
    "STUDIO+",
    "Topic",
    "twitch",
    "Twitter",
    "UEFA.tv",
    "Viafree",
    "Viaplay",
    "VICE Video",
    "Viki",
    "Vimeo",
    "Viu",
    "VizAnime",
    "WatanFlix",
    "WeTV",
    "Weverse",
    "WOW Presents",
    "WWNLive",
    "XBOX Live",
    "xHamster",
    "YouNow",
    "YouTube",
    "YouTube Premium",
  ],
  "United States": [
    "20th Television",
    "3waytv.tv",
    "ABC.com",
    "Acorn TV",
    "AdultSwim.com",
    "ALLBLK",
    "AMC Premiere",
    "AMC+",
    "amc.com",
    "AOL On",
    "Atom.com",
    "B/RLive",
    "BET+",
    "Blip",
    "bon appétit video",
    "Brat",
    "BrokenSaints.com",
    "BYUtv",
    "Cartoon Hangover",
    "CC: Studios",
    "Channel 101",
    "CHIKARAtopia",
    "Collegehumor",
    "Complex",
    "CONtv",
    "Crackle",
    "Crackle Spotlight",
    "Crunchyroll",
    "CuriosityStream",
    "CW Seed",
    "Dailymotion",
    "davidlynch.com",
    "Daybreak2012.com",
    "DC Universe",
    "Dekkoo",
    "DirecTV Now",
    "discovery+",
    "DisneyNOW",
    "Dove Channel",
    "Dramafever",
    "Dropout",
    "ESPN+",
    "ESPN3",
    "Explosm",
    "Eyeslicer.com",
    "Fangdango",
    "FilmOn",
    "Floslam",
    "FOXNow",
    "Freeform",
    "fullscreen",
    "Funimation",
    "Funny or Die",
    "fxnetworks",
    "GAS Digital",
    "Geek and Sundry",
    "GeekNation",
    "go90",
    "Hallmark Channel Everywhere",
    "Hallmark Movies Now",
    "Halo Waypoint",
    "Hasbro Studios",
    "HBO Go",
    "HBO Max",
    "HDnet",
    "Hill.TV",
    "History Channel",
    "Hulu",
    "IMDb TV",
    "Jash",
    "Jauntvr",
    "Jetix Web Channel",
    "Kartoon Channel!",
    "Koldcast.tv",
    "loboonline.com",
    "LouisCK.net",
    "LStudio.com",
    "Machinima.com",
    "Magnolia Network",
    "Maker.tv",
    "MOJO HD",
    "Motor Trend On Demand",
    "MTV.com",
    "Munchies",
    "mylifetime.com",
    "NBC News Signal",
    "NBC.com",
    "Nick App",
    "PantaYA",
    "PBS",
    "Peacock",
    "Pioneer One TV",
    "piperspicks.tv",
    "Playstation",
    "Pluto TV",
    "Pokerstars.com",
    "Project Alpha",
    "projectphoenix.tv",
    "Rides.tv",
    "Rooster Teeth",
    "ScreenMagic TV",
    "Seeso",
    "ShoutFactoryTV",
    "Showtime on Demand",
    "Shudder",
    "Smithsonian Earth",
    "SpaceJanitors.com",
    "Spectrum On Demand",
    "spike.com",
    "Spotify",
    "Sprint TV",
    "startrekcontinues.com",
    "stnv.de",
    "SundanceTV",
    "Super Deluxe",
    "Syfy",
    "TBS.com",
    "TED.com",
    "Tello",
    "The Fantasy Network",
    "The Zeus Network",
    "TheBlaze",
    "TheWB.com",
    "TLCgo",
    "TravelChannel.com",
    "Tubi",
    "TVNweather",
    "Twit",
    "TYSONPlus",
    "TYT",
    "UFC Fight Pass",
    "Ustream",
    "Vessel",
    "VidAngel",
    "VRV Select",
    "Vudu",
    "WWE Network",
    "WWNLIVE",
    "YAHOO! View",
    "Zeus",
  ],
  "United Kingdom": [
    "All 4",
    "BBC Doctor Who Webcast",
    "BBC iPlayer",
    "BBC Store",
    "BBC Three",
    "Demand Progress",
    "halcyonvr.com",
    "ITV Hub",
    "My5",
    "NOW TV",
    "Sky Go",
    "Sky Kids",
  ],
  Canada: [
    "canalvie.com",
    "CBC Comedy",
    "CBC Gem",
    "Citytv NOW",
    "Citytv.com",
    "Club illico",
    "CraveTV",
    "FemininFeminin.com",
    "Fight Network",
    "ICI Tou.tv",
    "OUTtvGo",
    "Stargate Command",
    "Steambot",
    "YTV.COM",
  ],
  Australia: ["10 Play", "7plus", "9Now", "ABC iView", "FOXTEL Now", "Stan"],
  Ireland: ["RTE PLAYER"],
  "New Zealand": ["ThreeNow", "TVNZ kidzone", "TVNZ OnDemand"],
  Bangladesh: ["Binge", "Bioscope", "Bongo"],
  Belgium: ["Play More", "RTBF Webcréation", "Streamz", "VTM GO"],
  Brazil: ["FOX Premium", "Globoplay"],
  China: [
    "Bilibili",
    "Blued",
    "Kankan",
    "LeTV",
    "Mango TV",
    "PPTV",
    "Sogou",
    "Sohu TV",
    "Tencent QQ",
    "Tudou",
    "U17",
    "Weibo",
    "Xuan Fun",
    "Youku",
  ],
  "Czech Republic": ["Stream.cz"],
  Denmark: ["TV2 Play"],
  Egypt: ["Watch iT!"],
  Finland: ["C More Finland", "Elisa Viihde", "ToonsTV", "Yle Areena"],
  France: [
    "Allociné",
    "ARTE.tv",
    "Blackpills",
    "France tv slash",
    "myCANAL",
    "Studio 4",
  ],
  Germany: [
    "ARD Mediathek",
    "Joyn",
    "MagentaTV",
    "maxdome",
    "MyVideo",
    "sat1.de",
    "Sky Go",
    "TVNOW",
    "ZDFmediathek",
  ],
  Greece: ["Cosmote TV"],
  "Hong Kong": ["hmvod", "myTV SUPER", "TVB Anywhere"],
  Hungary: ["OzoneTV"],
  India: [
    "Addatimes",
    "aha",
    "ALT Balaji",
    "EPIC On",
    "Gemplex",
    "Hoichoi",
    "Hotstar",
    "Hungama",
    "JioCinema",
    "MX Player",
    "SonyLIV",
    "TVFPlay",
    "voot",
    "ZEE5",
  ],
  Indonesia: ["GoPlay"],
  "Iran, Islamic Republic of": ["shahrzadseries.com"],
  Israel: ["sdarot.tv"],
  Italy: ["Rai Gulp", "RaiPlay", "TIMvision"],
  Japan: [
    "AbemaTV",
    "Animate.tv",
    "Bandai Channel",
    "BeeTV",
    "ComicFesta",
    "Comico",
    "DDTUniverse",
    "Docomo Anime Store",
    "dTV",
    "FOD",
    "GANMA！",
    "Gundam Fan Club",
    "GYAO!",
    "Hikari TV",
    "Hulu Japan",
    "LINE NEWS",
    "Mental Anime",
    "MixChannel",
    "Niconico",
    "Nifty",
    "NJPW World",
    "NOTTV",
    "Paravi",
    "Piccoma TV",
    "romanov.x0.com",
    "Square Enix",
    "Tate Anime",
    "UULA",
    "Weekly Young Jump",
    "Yahoo! Japan",
    "Young Animal Densi",
  ],
  Kazakhstan: ["Aitube.kz"],
  "Korea, Republic of": [
    "Daum TvPot",
    "GomTV",
    "Kakao TV",
    "KSTAR",
    "Laftel",
    "M2",
    "Melon",
    "Mobidic",
    "Naver TVCast",
    "Olleh TV",
    "Pikicast",
    "Seezn",
    "TVING",
    "V LIVE",
    "wavve",
  ],
  Malaysia: ["iflix"],
  Maldives: ["Baiskoafu"],
  Mexico: ["Blim"],
  Netherlands: ["KPN Presenteert", "LINDA.tv", "NPO Start Plus", "Videoland"],
  Norway: ["NRK TV", "Null Video", "TV 2 Sumo", "VGTV"],
  Philippines: ["iWant"],
  Portugal: ["OPTO | SIC"],
  "Russian Federation": [
    "Chill",
    "ivi",
    "Kino1TV",
    "lateralsummer.com",
    "more.tv",
    "Okko",
    "Premier",
    "Rutube",
    "Seasonvar",
    "Start",
    "VK.com",
    "Амедиатека",
    "КиноПоиск HD",
    "МТС ТВ",
    "Новый Иллюзион",
  ],
  Senegal: ["Marodi.TV"],
  Singapore: ["HOOQ", "meWATCH"],
  Spain: [
    "ATRESplayer PREMIUM",
    "HBO España",
    "Movistar+",
    "Orange TV",
    "RTVE Playz",
  ],
  Sweden: ["C More", "SVT Play", "TV4 Play"],
  "Taiwan, Province of China": [
    "CHOCO TV",
    "CHT MOD",
    "Coture",
    "CTI TV",
    "ETtoday",
    "MyVideo",
    "Vidol",
  ],
  Thailand: ["AIS Play", "Mello"],
  Turkey: ["beIN CONNECT", "BluTV", "Exxen", "GAIN", "Kanal D", "Puhu TV"],
};

export default webChannel;
